/**
 * @fileoverview Copia um texto para a área de transferência. Usa a Clipboard API
 * e, se ela faltar ou for negada (contexto não seguro, WebView antigo), cai na
 * textarea oculta + execCommand. Retorna true se copiou.
 */

const legacyCopy = (text) => {
  const previousFocus = document.activeElement;
  // Dentro de um Dialog do MUI o foco fica preso nele: uma textarea solta no
  // body perderia o foco (e a seleção) antes do execCommand.
  const host = (previousFocus && previousFocus.closest && previousFocus.closest("[role='dialog']")) || document.body;
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.top = "0";
  ta.style.left = "0";
  ta.style.opacity = "0";
  ta.style.pointerEvents = "none";
  host.appendChild(ta);
  try {
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    ta.remove();
    if (previousFocus && typeof previousFocus.focus === "function") previousFocus.focus();
  }
};

export const copyToClipboard = async (text) => {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return legacyCopy(text);
  }
};
